// extracted by mini-css-extract-plugin
module.exports = {"container":"DevicePopUp_container__2jZzB","scroll":"DevicePopUp_scroll__1_L41"};